import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { ACTIVE_NAV, ADMIN_NAV } from "@/components/feature/adminNav";
import { useAuth } from "@/context/AuthContext";

export default function AdminMobileNav() {
  const { profile, roleName, signOut } = useAuth();
  const navigate = useNavigate();
  const [sheetOpen, setSheetOpen] = useState(false);

  const upcoming = ADMIN_NAV.filter((item) => item.phase);
  const primary = ACTIVE_NAV.filter((item) =>
    ["dashboard", "pos", "products", "inventory"].includes(item.key),
  );

  const handleSignOut = async () => {
    setSheetOpen(false);
    await signOut();
    navigate("/login", { replace: true });
  };

  return (
    <>
      <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-background-200 bg-background-50/95 pb-[env(safe-area-inset-bottom)] backdrop-blur lg:hidden">
        <div className="grid grid-cols-5">
          {primary.map((item) => (
            <NavLink
              key={item.key}
              to={item.path}
              end={item.path === "/admin"}
              className={({ isActive }) =>
                `flex flex-col items-center gap-1 px-1 py-2.5 text-[11px] font-medium transition-colors ${
                  isActive ? "text-primary-600" : "text-foreground-500"
                }`
              }
            >
              <span className="flex h-6 w-6 items-center justify-center">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <span className="truncate">{item.label.split(" ")[0]}</span>
            </NavLink>
          ))}
          <button
            type="button"
            onClick={() => setSheetOpen(true)}
            className="flex flex-col items-center gap-1 px-1 py-2.5 text-[11px] font-medium text-foreground-500 transition-colors"
          >
            <span className="flex h-6 w-6 items-center justify-center">
              <i className="ri-menu-3-line text-xl"></i>
            </span>
            <span>Más</span>
          </button>
        </div>
      </nav>

      {sheetOpen ? (
        <div className="fixed inset-0 z-50 flex items-end bg-foreground-950/50 backdrop-blur-sm lg:hidden">
          <button
            type="button"
            aria-label="Cerrar"
            onClick={() => setSheetOpen(false)}
            className="absolute inset-0 h-full w-full cursor-default"
          />
          <div className="animate-slide-up relative z-10 max-h-[85vh] w-full overflow-y-auto rounded-t-lg border border-background-200 bg-background-50 pb-[env(safe-area-inset-bottom)]">
            <div className="flex items-center justify-between border-b border-background-200 px-5 py-4">
              <h2 className="font-heading text-base font-semibold text-foreground-950">Menú</h2>
              <button
                type="button"
                onClick={() => setSheetOpen(false)}
                className="flex h-8 w-8 items-center justify-center rounded-md text-foreground-500 hover:bg-background-200"
              >
                <i className="ri-close-line text-lg"></i>
              </button>
            </div>

            <div className="px-5 py-4">
              <div className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-100 px-4 py-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-sm font-bold text-background-50">
                  {(profile?.full_name?.[0] ?? "A").toUpperCase()}
                </span>
                <div className="min-w-0">
                  <p className="truncate text-sm font-semibold text-foreground-950">
                    {profile?.full_name} {profile?.last_name}
                  </p>
                  <p className="truncate text-xs text-foreground-500">
                    {roleName === "admin" ? "Administrador" : "Cajero"}
                  </p>
                </div>
              </div>

              <p className="px-1 pb-2 pt-5 text-[11px] font-semibold uppercase tracking-wider text-foreground-400">
                Disponibles
              </p>
              <div className="flex flex-col gap-1">
                {ACTIVE_NAV.map((item) => (
                  <NavLink
                    key={item.key}
                    to={item.path}
                    onClick={() => setSheetOpen(false)}
                    className="flex items-center gap-3 rounded-md px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-background-100"
                  >
                    <span className="flex h-5 w-5 items-center justify-center text-foreground-500">
                      <i className={`${item.icon} text-lg`}></i>
                    </span>
                    {item.label}
                  </NavLink>
                ))}
              </div>

              <p className="px-1 pb-2 pt-5 text-[11px] font-semibold uppercase tracking-wider text-foreground-400">
                Próximas fases
              </p>
              <div className="flex flex-col gap-1">
                {upcoming.map((item) => (
                  <div
                    key={item.key}
                    className="flex cursor-default items-center gap-3 rounded-md px-3 py-3 text-sm text-foreground-400"
                  >
                    <span className="flex h-5 w-5 items-center justify-center">
                      <i className={`${item.icon} text-lg`}></i>
                    </span>
                    <span className="min-w-0 flex-1 truncate">{item.label}</span>
                    <span className="rounded-full bg-background-200 px-2 py-0.5 text-[10px] font-semibold text-foreground-500">
                      Fase {item.phase}
                    </span>
                  </div>
                ))}
              </div>

              <button
                type="button"
                onClick={handleSignOut}
                className="mt-5 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-200 bg-primary-50 px-4 py-3 text-sm font-semibold text-primary-700"
              >
                <i className="ri-logout-box-r-line text-base"></i>
                Cerrar sesión
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}